﻿module.exports = function ($) {
    return {
        init: function () {
            $(window).on('hashchange', function () {
                if (window.location.hash === "#forgotten-password") {
                    $("#LoginForm").hide();
                    $("#ForgottenPasswordForm").show();
                } else {
                    $("#LoginForm").show();
                    $("#ForgottenPasswordForm").hide();
                }
            });
            $(window).trigger('hashchange');
            $("#LoginForm input").on("keyup", function (e) {
                if (e.keyCode === 13) {
                    $("#LoginForm").submit();
                }
            });
            $("#ForgottenPasswordForm input").on("keyup", function (e) {
                if (e.keyCode === 13) {
                    $("#ForgottenPasswordForm").submit();
                }
            });
        }
    }
} 